import {
  type Link1Card,
  Link1CardSchema,
  type Link2Card,
  Link2CardSchema,
  type Link3Card,
  Link3CardSchema,
  type Link4Card,
  Link4CardSchema,
  type Link5Card,
  Link5CardSchema,
  type Link6Card,
  Link6CardSchema,
} from "@stackje/common/config";
import { ValidationError } from "./validation";

type LinkCard =
  | Link1Card
  | Link2Card
  | Link3Card
  | Link4Card
  | Link5Card
  | Link6Card;

export function parseLinkCard(formData: FormData): LinkCard {
  const type = formData.get("type") as LinkCard["type"];
  const baseCard = {
    colors: JSON.parse(formData.get("colors") as string),
    title: (formData.get("title") as string) || undefined,
    description: (formData.get("description") as string) || undefined,
    imageSize: formData.get("imageSize")
      ? Number(formData.get("imageSize"))
      : undefined,
  };

  // Parse links from indexed form fields
  const links = [];
  let i = 0;
  while (formData.has(`linkTitle${i}`)) {
    links.push({
      title: formData.get(`linkTitle${i}`) as string,
      url: formData.get(`linkUrl${i}`) as string,
      description: (formData.get(`linkDescription${i}`) as string) || undefined,
      image: formData.get(`linkImageSrc${i}`)
        ? {
            src: formData.get(`linkImageSrc${i}`) as string,
            alt: formData.get(`linkImageAlt${i}`) as string ?? baseCard.title,
          }
        : undefined,
    });
    i++;
  }

  const cardData = { ...baseCard, type, links };

  try {
    switch (type) {
      case "link1":
        return Link1CardSchema.parse(cardData);
      case "link2":
        return Link2CardSchema.parse(cardData);
      case "link3":
        return Link3CardSchema.parse(cardData);
      case "link4":
        return Link4CardSchema.parse(cardData);
      case "link5":
        return Link5CardSchema.parse(cardData);
      case "link6":
        return Link6CardSchema.parse(cardData);
      default:
        throw new Error(`Invalid link card type: ${type}`);
    }
  } catch (error) {
    if (error instanceof Error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw new ValidationError(error as any);
    }
    throw error;
  }
}
